var styleDataHash = "9f340236";
const injectCss = () => {
  var css = `.uV4uA{margin-left:0;margin-right:auto;z-index:1}.uV4uA:not(.yc47l){float:left;margin-right:40px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.uV4uA:not(.yc47l){float:none;margin-right:auto}}}@container (width < 640px){.uV4uA:not(.yc47l){float:none;margin-right:auto}}.YL9VQ{margin-left:auto;margin-right:0;z-index:1}.YL9VQ:not(.yc47l){float:right;margin-left:40px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.YL9VQ:not(.yc47l){float:none;margin-left:auto}}}@container (width < 640px){.YL9VQ:not(.yc47l){float:none;margin-left:auto}}.-sqmX{clear:both;display:block}.-sqmX:not(.w-khN){margin-left:auto;margin-right:auto;max-width:100%}.w-khN,.yc47l{width:100%}.SpdyC .w-khN,.SpdyC .yc47l{margin:0 -8px;width:auto}.oLUUG{width:fit-content}._5Eibh{margin-left:auto;margin-right:auto;max-width:100%}.vaOok{width:min(350px,100%)!important}.SpdyC .vaOok{width:50%}.xp8-e{margin-left:auto;margin-right:auto}.SpdyC .xp8-e{width:150px}.nm8sS{display:flex}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var general_rtlignore_default = {
  "alignLeft": "uV4uA",
  "textWrapNowrap": "yc47l",
  "alignRight": "YL9VQ",
  "alignCenter": "-sqmX",
  "sizeFullWidth": "w-khN",
  "renderedInTable": "SpdyC",
  "sizeOriginal": "oLUUG",
  "sizeContent": "_5Eibh",
  "sizeSmall": "vaOok",
  "sizeSmallCenter": "xp8-e",
  "flex": "nm8sS"
};
export {
  general_rtlignore_default as default,
  injectCss
};
//# sourceMappingURL=general.rtlignore-scss.js.map
